// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payment-reminder {
  margin-bottom: 15px;
  color: white !important;
  padding: 20px;
  text-align: center;
  width: 100%;
  border-radius: 10px;
  font-family: Arial, sans-serif;
  margin-bottom: 70px;
}

.payment-reminder .p-button {
  background-color: white;
  color: var(--primary-color);
  border: none;
  padding: 10px 20px;
  margin-top: 10px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
}

.payment-reminder .p-button:hover {
  background-color: #f2f2f2;
  color: var(--primary-color);
}`, "",{"version":3,"sources":["webpack://./src/app/layout/app.menuitem.component.ts"],"names":[],"mappings":"AACY;EACI,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAAhB;;AAGY;EACI,uBAAA;EACA,2BAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAAhB;;AAGY;EACI,yBAAA;EACA,2BAAA;AAAhB","sourcesContent":["\n            .payment-reminder {\n                margin-bottom: 15px;\n                color: white !important;\n                padding: 20px;\n                text-align: center;\n                width: 100%;\n                border-radius: 10px;\n                font-family: Arial, sans-serif;\n                margin-bottom: 70px;\n            }\n\n            .payment-reminder .p-button {\n                background-color: white;\n                color: var(--primary-color);\n                border: none;\n                padding: 10px 20px;\n                margin-top: 10px;\n                border-radius: 5px;\n                cursor: pointer;\n                font-weight: bold;\n            }\n\n            .payment-reminder .p-button:hover {\n                background-color: #f2f2f2;\n                color: var(--primary-color);\n            }\n        "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
